// extracted by mini-css-extract-plugin
module.exports = {"page-title":"pageTitle_page-title__wIEht","title":"pageTitle_title__vQcd4","subtitle":"pageTitle_subtitle__vNaaw"};